import React from "react";
import Modal from "./Modal";
import { useTheme } from "./theme";

interface HireTesterModalProps {
  open: boolean;
  onClose: () => void;
}

export default function HireTesterModal({ open, onClose }: HireTesterModalProps) {
  const { theme } = useTheme();
  const palette = theme.palette;

  if (!open) return null;

  return (
    <Modal title="Hire a Tester" onClose={onClose}>
      <div
        style={{
          display: "grid",
          gap: "1.5rem",
        }}
      >
        <div>
          <div
            style={{
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              color: palette.accent,
              fontSize: "0.75rem",
              marginBottom: "0.35rem",
            }}
          >
            Why hire a tester
          </div>
          <h4
            style={{
              margin: 0,
              color: palette.textPrimary,
              fontSize: "1.1rem",
              fontWeight: 600,
            }}
          >
            Senior QA experts on-demand
          </h4>
          <p style={{ color: palette.textMuted, marginTop: "0.75rem" }}>
            Every LaunchSafely tester is a vetted, professional QA specialist. We match you with
            analysts who live inside QA tooling all day, understand modern release pipelines, and
            treat your product quality like their own.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gap: "1rem",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          }}
        >
          <div
            style={{
              border: `1px solid ${palette.border}`,
              borderRadius: "10px",
              padding: "1rem",
              background: palette.cardAlt,
              color: palette.textSecondary,
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: "0.4rem" }}>From results to insight</div>
            <p
              style={{
                margin: 0,
                color: palette.textMuted,
                fontSize: "0.9rem",
              }}
            >
              Your assigned tester reviews this run, re-validates failures, and expands test coverage
              where needed. Expect deep analysis, reproduction proof, and prioritized
              recommendations.
            </p>
          </div>
          <div
            style={{
              border: `1px solid ${palette.border}`,
              borderRadius: "10px",
              padding: "1rem",
              background: palette.cardAlt,
              color: palette.textSecondary,
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: "0.4rem" }}>Beyond manual checks</div>
            <p
              style={{
                margin: 0,
                color: palette.textMuted,
                fontSize: "0.9rem",
              }}
            >
              Our testers operate LaunchSafely&apos;s custom tooling, build automation scripts, validate
              APIs, and log verified bugs for your developers. Need additional QA services? They can
              extend coverage on request.
            </p>
          </div>
        </div>

        <div
          style={{
            border: `1px solid ${palette.border}`,
            borderRadius: "10px",
            padding: "1rem",
            background: palette.cardAlt,
            color: palette.textMuted,
          }}
        >
          <div
            style={{
              fontWeight: 600,
              color: palette.textPrimary,
              marginBottom: "0.5rem",
            }}
          >
            How engagement works
          </div>
          <ul
            style={{
              paddingLeft: "1.1rem",
              margin: 0,
              display: "grid",
              gap: "0.4rem",
              fontSize: "0.9rem",
            }}
          >
            <li>
              We assign a tester instantly, or you can browse our directory of specialist profiles to
              choose the perfect fit.
            </li>
            <li>
              They replay your failing scenarios, capture logs, and produce a shipping-ready triage
              report with next steps.
            </li>
            <li>
              Optional add-ons: test automation builds, API contract validation, accessibility audits,
              and more.
            </li>
          </ul>
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "0.75rem",
            alignItems: "center",
          }}
        >
          <button
            style={{
              padding: "0.7rem 1.4rem",
              borderRadius: "8px",
              border: "none",
              fontWeight: 600,
              background: palette.accentGradient,
              color: "#fff",
              cursor: "pointer",
            }}
          >
            Start Your Engagement ($39/run)
          </button>
          <button
            style={{
              padding: "0.65rem 1.2rem",
              borderRadius: "8px",
              border: `1px solid ${palette.border}`,
              background: palette.cardAlt,
              color: palette.textMuted,
              cursor: "pointer",
            }}
          >
            Browse Tester Directory
          </button>
        </div>
      </div>
    </Modal>
  );
}
